import { useState, type FormEvent } from "react";
import { ApiError, login, register, type AuthResult } from "../api";

export function LoginScreen({ onAuth }: { onAuth: (result: AuthResult) => void | Promise<void> }) {
  const [mode, setMode] = useState<"login" | "register">("login");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true); setError("");
    try {
      const result = mode === "login" ? await login(username, password) : await register(username, password, displayName || username);
      await onAuth(result);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "Could not reach the DM Screen service");
    } finally { setBusy(false); }
  }

  return (
    <div className="gate">
      <form className="gate-card" onSubmit={submit}>
        <div className="brand">
          <span className="brand-mark">✦</span>
          <div><strong>LoreMaster's Compass</strong><small>DM Screen</small></div>
        </div>
        <h1>{mode === "login" ? "Sign in to your DM profile" : "Create your DM profile"}</h1>
        <label>Username<input value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" required minLength={3} /></label>
        <label>Password<input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete={mode === "login" ? "current-password" : "new-password"} required minLength={8} /></label>
        {mode === "register" && <label>Display name<input value={displayName} onChange={(e) => setDisplayName(e.target.value)} autoComplete="name" /></label>}
        {error && <p className="error" role="alert">{error}</p>}
        <button type="submit" disabled={busy}>{busy ? "One moment…" : mode === "login" ? "Sign in" : "Create profile"}</button>
        <button type="button" className="link" onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }}>
          {mode === "login" ? "New here? Create a profile" : "Already have a profile? Sign in"}
        </button>
        <p className="muted small">Moving from the old site? Sign in, then use <a href="/import.html">the import page</a> to bring your export across.</p>
        <p className="muted small"><a href="/download.html">Get the Compass</a> · <a href="/connector.html">Get the connector</a> · <a href="/help.html">Getting started</a> · <a href="/connector-privacy.html">Privacy</a></p>
      </form>
    </div>
  );
}
